import { func, number } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../../generic/Tooltip/get-info-tooltip';
import withConfirm from '../../../generic/with-confirm';
import { generateBookingEntries } from '../../actions/booking-entry-actions';
import HELP_TEXTS from '../../help-texts';

function GenerateBookingEntriesButton({ onClick, opportunityId, ...rest }) {
  return (
    <Button onClick={() => onClick(opportunityId)} {...rest}>
      Generate Media Entries{' '}
      {getInfoTooltip(
        HELP_TEXTS,
        'generateMediaEntries',
        'actionButtons',
        'top',
      )}
    </Button>
  );
}

GenerateBookingEntriesButton.propTypes = {
  onClick: func.isRequired,
  opportunityId: number.isRequired,
};

const GenerateWithConfirmation = withConfirm(
  'Do you really want to initiate generating new booking entries for this opportunity?',
)(GenerateBookingEntriesButton);

const mapDispatchToProps = {
  onClick: generateBookingEntries,
};

export default connect(null, mapDispatchToProps)(GenerateWithConfirmation);
